var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapp-add-to-cart"},[_c('button',{staticClass:"btn btn-primary btn-add-to-cart",on:{"click":_vm.addToCart}},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }